import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
// import CoupanServices from '../../services/CoupanServices';

function AddProvider() {
    const navigate = useNavigate();
    const [formValues, setFormValues] = useState({
        name: "",
        websiteUrl: "",
        description: "",
        logo: "",
        status: "Active",
    });
    const [loading, setLoading] = useState(false);
    const [imagePreview, setImagePreview] = useState(null);
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormValues((prev) => ({
            ...prev,
            [name]: value,
        }));
    };
    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setFormValues((prev) => ({
                ...prev,
                logo: file,
            }));

            setImagePreview(URL.createObjectURL(file));
        } else {
            setFormValues((prev) => ({
                ...prev,
                logo: "",
            }));
            setImagePreview(null);
        }
    };
    const validateForm = () => {

        if (!formValues.name.trim()) {
            alert("Please enter provider name.");
            return false;
        }

        if (!formValues.websiteUrl.trim()) {
            alert("Please enter website URL.");
            return false;
        }

        // Basic URL validation
        try {
            new URL(formValues.websiteUrl);
        } catch (error) {
            alert("Please enter a valid website URL.");
            return false;
        }

        return true;
    };
    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!validateForm()) return;
        setLoading(true);
        try {
            const providerData = {
                id: Date.now(),

                name: formValues.name.trim(),

                websiteUrl: formValues.websiteUrl.trim(),

                description: formValues.description.trim(),

                logo: formValues.logo,

                status: formValues.status,
            };

            console.log("Provider Data:", providerData);

            /*
            Later API:

            const formData = new FormData();

            formData.append("name", formValues.name);
            formData.append("websiteUrl", formValues.websiteUrl);
            formData.append("description", formValues.description);
            formData.append("status", formValues.status);

            if (formValues.logo) {
                formData.append("logo", formValues.logo);
            }

            await ProviderServices.createProvider(formData);
            */

            alert("Provider created successfully");

            navigate("/provider-list");

        } catch (error) {

            console.error("Failed to create provider:", error);

            alert("Failed to create provider");

        } finally {

            setLoading(false);

        }
    };

    return (
        <>
            <div className="right_col" role="main">
                <div className="d-md-flex align-items-center justify-content-between my-4 page-header-breadcrumb">
                    <div className="my-auto">
                        <h5 className="page-title fs-21 mb-1">
                            New Provider
                        </h5>
                        <nav>
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item">
                                    <a href="javascript:void(0);">Home</a>
                                </li>
                                <li className="breadcrumb-item active">
                                    Add Provider
                                </li>
                            </ol>
                        </nav>
                    </div>
                    <div className="d-flex my-xl-auto gap-2 right-content align-items-center">
                        <Link className="list-banner-btn" to="/provider-list">Provider List</Link>
                    </div>
                </div>

                <div className="container-box">
                    <div className="container-box-inner table-reponsive-tabe">
                        <div className="page-details">
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-lg-6 col-sm-12">
                                        <div className="input-field">
                                            <label>Provider Name <span className=""></span></label>
                                            <input
                                                type="text"
                                                name="name"
                                                className="form-control"
                                                value={formValues.name}
                                                onChange={handleInputChange}
                                                placeholder="Enter provider name (e.g., Amazon)"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-sm-12">

                                        <div className="input-field">

                                            <label>
                                                Website URL
                                                <span className="red">*</span>
                                            </label>

                                            <input
                                                type="url"
                                                name="websiteUrl"
                                                className="form-control"
                                                value={formValues.websiteUrl}
                                                onChange={handleInputChange}
                                                placeholder="https://www.amazon.in"
                                            />

                                        </div>

                                    </div>

                                    <div className="col-lg-6 col-sm-6">
                                        <div className="input-field">
                                            <label>  Provider Logo:</label>
                                            <input
                                                type="file"
                                                name="logo"
                                                className="form-control"
                                                accept="image/*"
                                                onChange={handleImageChange}
                                            />
                                            {imagePreview && (

                                                <div style={{ marginTop: "10px" }}>

                                                    <img
                                                        src={imagePreview}
                                                        alt="Provider Logo Preview"
                                                        style={{
                                                            width: "120px",
                                                            height: "120px",
                                                            objectFit: "contain",
                                                            border: "1px solid #ccc",
                                                            borderRadius: "8px",
                                                            padding: "5px",
                                                        }}
                                                    />

                                                </div>

                                            )}
                                        </div>
                                    </div>

                                    <div className="col-lg-6 col-sm-12">

                                        <div className="input-field">

                                            <label>
                                                Status
                                                <span className="red">*</span>
                                            </label>

                                            <select
                                                name="status"
                                                className="form-control"
                                                value={formValues.status}
                                                onChange={handleInputChange}
                                            >

                                                <option value="Active">
                                                    Active
                                                </option>

                                                <option value="Inactive">
                                                    Inactive
                                                </option>

                                            </select>

                                        </div>

                                    </div>
                                    <div className="col-lg-12 col-sm-12">

                                        <div className="input-field">

                                            <label>
                                                Description
                                            </label>

                                            <textarea
                                                className="form-control video-desc h-auto"
                                                name="description"
                                                value={formValues.description}
                                                onChange={handleInputChange}
                                                placeholder="Enter provider description"
                                                rows="4"
                                            />

                                        </div>

                                    </div>


                                </div>

                                <div className="text-center mt-4">
                                    <button
                                        className="submit-green-btn"
                                        type="submit"
                                        disabled={loading}
                                        style={{ minWidth: '150px' }}
                                    >
                                        {loading ? 'SUBMITTING...' : 'SUBMIT'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AddProvider;